import React, {createRef} from 'react';
import {v4 as uuidv4} from "uuid";
import TextComponent from "../input/TextComponent";
import Dropzone from "react-dropzone";
import {Badge, Button, Col, Row} from "react-bootstrap";
import TextInputFormField from "../formFields/TextInputFormField";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import NumberInputFormField from "../formFields/NumberInputFormField";
import config from "../../config";
import ModelViewer from "../3DViewer";
import APIController from "../../controller/APIController";
import FileUtil from "../../util/FileUtil";

class ImageContentTextComponent extends TextComponent {
    constructor(props) {
        super(props);
        this.component = props.component;
        this.dropzoneRef = createRef();
        this._handleChange = this._handleChange.bind(this);
        this.updateComponent = props.updateComponent;
        this.onDrop = this.onDrop.bind(this);

        this.state = {
            fetching: true,
            filesWithMeta: {}
        }
        this.onLoadingFinished = props.onLoadingFinished;
    }

    async reload() {
        this.setState(prevState => ({
            ...prevState,
            fetching: true,
        }));
        let filesWithMeta = await FileUtil.loadMediaFilesMeta(this.component.config.files,this.props.printMode);
        this.onLoadingFinished(this.component);
        this.setState(prevState => ({
            ...prevState,
            fetching: false,
            filesWithMeta: filesWithMeta
        }));
    }

    async componentDidMount() {
       await this.reload();
    }

    openDialog(){
        if (this.dropzoneRef.current) {
            this.dropzoneRef.current.open()
        }
    };

    _handleChange(id,value){
        this.component.config[id] = value;
        this.updateComponent(this.component);
    }

    static create(){
        return {
                id: uuidv4(),
                type : "image",
                description: "",
                title: "Grafik",
                data : {},
                config: {
                    files: [],
                    imageWidth:100,
                    comments: []
                }
            }
    }

    async onDrop(acceptedFiles){
        var self = this;
        for (const file of acceptedFiles) {
            let maxAllowedSize = this.component.config.maxFilesSize * 1024 * 1024;
            let fileResponse = await APIController.uploadFile(file,maxAllowedSize);
            if(fileResponse != null && fileResponse.url !== ""){
                self.component.config['files'].push(
                    fileResponse
                )
                self.updateComponent(self.component);
            }
        }
    }

    _updateFileName(component,fileId,newFileDescription){
        component.config.files.map( (file, idx) => {
            if(file.id === fileId){
                component.config.files[idx].description = newFileDescription;
            }
        });
    }

    _removeFileById(component,fileId){
        component.config.files.map( (file, idx) => {
            if(file.id === fileId){
                fetch(
                    `${config.API_HOST_URL}/files/${file.name}`,
                    {
                        credentials: "include",
                        method: "DELETE",
                    }
                ).then(function(response) {
                    return response.json();
                })
                component.config.files.splice(idx, 1);
            }
        });
    }

    renderEditorView(){
        return (
            <div>
                <Dropzone key={"Dropzone" + Math.random().toString()} onDrop={this.onDrop} ref={this.dropzoneRef} noClick noKeyboard>
                    {({getRootProps, getInputProps, acceptedFiles}) => {

                        return (
                            <div>
                                <div {...getRootProps({className: 'dropzone'})}>
                                    <input {...getInputProps()} />
                                    <p>Drag & Drop Dateien hier</p>
                                    <button
                                        type="button"
                                        onClick={() => this.openDialog()}
                                    >
                                        Datei auswählen
                                    </button>
                                </div>
                                <br />
                                {this.component.config['files'].map(file => (
                                    <Row key={file.id}>
                                        <Col className={'mb-1'} xs={12} lg={5}>
                                            <TextInputFormField
                                                title={""}
                                                rows={1}
                                                placeholder={"Titel/Beschreibung"}
                                                description={""}
                                                onChange={(value) => {
                                                    this._updateFileName(this.component,file.id,value);
                                                    //this.updateComponent(this.component);
                                                }}
                                                value={file.description}
                                            />
                                        </Col>
                                        <Col className={'mb-1'} xs={12} lg={2}>
                                            <Button style={{marginRight:'0.5em'}} onClick={() => {
                                                window.open(
                                                    file.url,
                                                    '_blank'
                                                  )
                                            }}>
                                                <FontAwesomeIcon icon={faDownload} />
                                            </Button>
                                            <Button onClick={() => {
                                                if (window.confirm("Grafik: '" + file.description + "' wirklich löschen?")) {
                                                    this._removeFileById(this.component,file.id);
                                                    this.updateComponent(this.component);
                                                }
                                            }}>
                                                <FontAwesomeIcon icon={faTrashCan} />
                                            </Button>
                                        </Col>
                                        <Col className={'mb-1'} xs={12} lg={5}>
                                            {(file.type == "image/png"
                                                || file.type== "image/jpeg"
                                                || file.type== "image/jpg")
                                                ? <img src={file.url} style={{height:'2em'}} />
                                                : (file.type == "application/octet-stream")
                                                    ? <ModelViewer file={file} /> : <Badge bg={"dark"}>{file.extension}</Badge>
                                            }
                                        </Col>
                                    </Row>
                                ))}
                            </div>
                        );
                    }}
                </Dropzone>
                <div>
                    <h3>Darstellung</h3>
                    <Row>
                        <Col>
                            <NumberInputFormField
                                title={"Breite in Prozent"}
                                description={"Wieviele Zeilen soll die Tabelle haben?"}
                                maxValue={100}
                                suffix={"%"}
                                steps={10}
                                value={this.component.config.imageWidth}
                                onChange={(value) => this._handleChange('imageWidth',value)}
                            />
                        </Col>
                        <Col>

                        </Col>
                    </Row>
                </div>
            </div>
        );
    }





    renderInputView(){
        return FileUtil.renderFiles(this.state.filesWithMeta,this.props.printMode,false);
    }

    render() {

        if(this.state.fetching){
            return "Loading ...";
        }

        if(this.props.instructorMode){
            return <div>
                {/*JSON.stringify(this.component)*/}
                {this.renderInputView()}
            </div>
        } else if(this.props.showEditorView){
            return <div>
                {/*JSON.stringify(this.component)*/}
                {this.renderEditorView()}
            </div>
        }else{
            return <div>
                {/*JSON.stringify(this.component)*/}
                {this.renderInputView()}
            </div>
        }
    }
}
export default ImageContentTextComponent;